export default "__VITE_ASSET__BBCniDGV__"